import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section className="hero" id="hero">
      <h1>Empowering Businesses with Innovative IT Solutions</h1>
      <p>We deliver tailored software services that drive your success.</p>
      <div className="hero-buttons">
        <a href="#contact" className="cta">Get In Touch</a>
        <a href="#services" className="cta cta-secondary">Our Services</a>
      </div>
    </section>
  );
}

export default Hero;
